import { css } from '@emotion/react'
import { MyLabel } from '../../reducers/sourcingAnnotationCandidates'
import { colors } from 'plume-ui'

export const MyLabelItem: React.FC<{ myLabel: MyLabel; maxWidth: string }> = ({
  myLabel,
  maxWidth,
}) => {
  return (
    <li
      data-test-id="my-label-item"
      css={css`
        font-size: 12px;
        line-height: 1.5;
        border-radius: 3px;
        padding: 2px 6px;
        background-color: ${colors.white00};
        border: 1px solid ${colors.gray50};
        color: ${colors.gray90};
        display: inline-block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: ${maxWidth}; // TODO: いる？外でやれば良くない？
      `}
    >
      {myLabel.name}
    </li>
  )
}
